/* React */
import React from "react";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Utils */
import { createChartLegendInfo } from "src/utils/helper/legend";

/* Components */
import ChartLegend from "src/components/charts/chart-legend/ChartLegend";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { DescriptiveStatisticsProps } from "src/shared/interfaces/DescriptiveStatistics";
import { SurvivalAnalysisProps } from "src/shared/interfaces/SurvivalAnalysis";

const createChartLegend = (
  type: ChartType,
  data: BaseChartProps<
    DescriptiveStatisticsProps | SurvivalAnalysisProps,
    ChartType[]
  >,
  showNoValueEntries?: boolean
) => {
  const chartLegendInfo = createChartLegendInfo(
    type,
    data.data[type],
    showNoValueEntries
  );

  return <ChartLegend chartLegendInfo={chartLegendInfo} />;
};

export default createChartLegend;
